function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import { Vector as olLayerVector } from 'ol/layer';
import { Vector as olSourceVector } from 'ol/source';
import { Style, Fill, Stroke, Circle } from 'ol/style';
import { Draw, Modify, Snap } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import { ensureMap } from '../../hocs/ensureMap';
import { provideMapState } from '../../hocs/provideMapState';
var defaultFontColor = 'rgb(255, 255, 255)';
var defaultFillColor = 'rgb(238, 153, 0)';
var defaultOpacity = 100;
var defaultPointRadius = 10;
var defaultStrokeWidth = 2;
var defaultModifyCircleFillColor = 'rgb(27, 140, 247)';
var defaultModifyCircleStrokeColor = 'rgb(27, 140, 247)';
var defaultModifyCircleRadius = 5;
var defaultModifyFillColor = 'rgb(27, 140, 247)';
var defaultModifyStrokeColor = 'rgb(27, 140, 247)';
var defaultLineDash = [];
var defaultLineDashOffset = 0;
var LayerStyle = process.env.NODE_ENV !== "production" ? PropTypes.shape({
  pointRadius: PropTypes.number,
  fillColor: PropTypes.string,
  fillOpacity: PropTypes.number,
  strokeColor: PropTypes.string,
  strokeOpacity: PropTypes.number,
  strokeWidth: PropTypes.number,
  modifyCircleFillOpacity: PropTypes.number,
  modifyCircleStrokeOpacity: PropTypes.number,
  modifyCircleStrokeColor: PropTypes.string,
  modifyCircleRadius: PropTypes.number,
  modifyCircleFillColor: PropTypes.string,
  modifyFillColor: PropTypes.string,
  modifyFillOpacity: PropTypes.number,
  modifyStrokeColor: PropTypes.string,
  modifyStrokeOpacity: PropTypes.number,
  lineDash: PropTypes.array,
  lineOffset: PropTypes.number
}) : {};
function hexToRGB(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacity / 100 + ')';
}
function createRGB(rgb, opacity) {
  if (rgb.indexOf('rgb') > -1) {
    return rgb;
  }
  return 'rgba(' + rgb.replace(/\s/g, ',') + ', ' + opacity / 100 + ')';
}
function convertColor(value, opacity) {
  if (value.indexOf('#') > -1) {
    return hexToRGB(value, opacity);
  } else {
    return createRGB(value, opacity);
  }
}
function getFeatureStyle(featureStyle) {
  featureStyle = featureStyle || {};
  var _featureStyle = featureStyle,
    pointRadius = _featureStyle.pointRadius,
    fillColor = _featureStyle.fillColor,
    fillOpacity = _featureStyle.fillOpacity,
    strokeColor = _featureStyle.strokeColor,
    strokeOpacity = _featureStyle.strokeOpacity,
    strokeWidth = _featureStyle.strokeWidth,
    fontColor = _featureStyle.fontColor,
    modifyCircleFillColor = _featureStyle.modifyCircleFillColor,
    modifyCircleStrokeColor = _featureStyle.modifyCircleStrokeColor,
    modifyCircleRadius = _featureStyle.modifyCircleRadius,
    modifyCircleFillOpacity = _featureStyle.modifyCircleFillOpacity,
    modifyCircleStrokeOpacity = _featureStyle.modifyCircleStrokeOpacity,
    modifyFillColor = _featureStyle.modifyFillColor,
    modifyStrokeColor = _featureStyle.modifyStrokeColor,
    modifyFillOpacity = _featureStyle.modifyFillOpacity,
    modifyStrokeOpacity = _featureStyle.modifyStrokeOpacity,
    modifyStrokeWidth = _featureStyle.modifyStrokeWidth,
    lineDash = _featureStyle.lineDash,
    lineDashOffset = _featureStyle.lineDashOffset;
  return {
    strokeWidth: strokeWidth || defaultStrokeWidth,
    strokeColor: convertColor(strokeColor || fillColor || defaultFillColor, strokeOpacity || defaultOpacity),
    fillColor: convertColor(fillColor || defaultFillColor, fillOpacity || defaultOpacity),
    fontColor: convertColor(fontColor || defaultFontColor),
    pointRadius: pointRadius || defaultPointRadius,
    modifyCircleRadius: modifyCircleRadius || defaultModifyCircleRadius,
    modifyCircleFillColor: convertColor(modifyCircleFillColor || defaultModifyCircleFillColor, modifyCircleFillOpacity || defaultOpacity),
    modifyCircleStrokeColor: convertColor(modifyCircleStrokeColor || defaultModifyCircleStrokeColor, modifyCircleStrokeOpacity || defaultOpacity),
    modifyFillColor: convertColor(modifyFillColor || defaultModifyFillColor, modifyFillOpacity || defaultOpacity),
    modifyStrokeColor: convertColor(modifyStrokeColor || defaultModifyStrokeColor, modifyStrokeOpacity || defaultOpacity),
    modifyStrokeWidth: modifyStrokeWidth || defaultStrokeWidth,
    lineDash: lineDash || defaultLineDash,
    lineDashOffset: lineDashOffset || defaultLineDashOffset
  };
}

/**
 *
 * @deprecated This is replaced by new VectorLayer and Draw interaction
 */
export var DrawLayer = /*#__PURE__*/function (_React$Component) {
  function DrawLayer() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DrawLayer, _React$Component);
  var _proto = DrawLayer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      map = _this$props.map,
      olGeomType = _this$props.olGeomType;
    var featureStyle = this.props.featureStyle;
    featureStyle = getFeatureStyle(featureStyle);
    if (map._drawLayers && map._drawLayers[this.id]) {
      map._drawLayers[this.id].layer.setVisible(true);
    }
    map._drawLayers = map._drawLayers || {};
    var layerSource = new olSourceVector();
    var layer = new olLayerVector({
      source: layerSource,
      style: new Style({
        fill: new Fill({
          color: featureStyle.fillColor
        }),
        stroke: new Stroke({
          color: featureStyle.strokeColor,
          width: featureStyle.strokeWidth
        }),
        image: new Circle({
          fill: new Fill({
            color: featureStyle.fillColor
          }),
          stroke: new Stroke({
            color: featureStyle.strokeColor,
            width: featureStyle.strokeWidth
          }),
          radius: featureStyle.pointRadius
        })
      })
    });
    var drawInt = undefined;
    if (olGeomType == 'DrawBox') {
      drawInt = new Draw({
        source: layerSource,
        type: 'Circle',
        geometryFunction: createBox(),
        style: new Style({
          fill: new Fill({
            color: featureStyle.modifyFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyStrokeColor,
            width: featureStyle.modifyStrokeWidth,
            lineDash: featureStyle.lineDash,
            lineDashOffset: featureStyle.lineDashOffset
          }),
          image: new Circle({
            radius: featureStyle.modifyCircleRadius,
            fill: new Fill({
              color: featureStyle.modifyCircleFillColor
            }),
            stroke: new Stroke({
              color: featureStyle.modifyCircleStrokeColor,
              width: featureStyle.modifyCircleStrokeWidth
            })
          })
        })
      });
    } else {
      drawInt = new Draw({
        source: layerSource,
        type: olGeomType,
        style: new Style({
          fill: new Fill({
            color: featureStyle.modifyFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyStrokeColor,
            width: featureStyle.modifyStrokeWidth,
            lineDash: featureStyle.lineDash,
            lineDashOffset: featureStyle.lineDashOffset
          }),
          image: new Circle({
            radius: featureStyle.modifyCircleRadius,
            fill: new Fill({
              color: featureStyle.modifyCircleFillColor
            }),
            stroke: new Stroke({
              color: featureStyle.modifyCircleStrokeColor,
              width: featureStyle.modifyCircleStrokeWidth
            })
          })
        })
      });
    }
    var modifyInt = new Modify({
      source: layerSource,
      style: new Style({
        image: new Circle({
          radius: featureStyle.modifyCircleRadius,
          fill: new Fill({
            color: featureStyle.modifyCircleFillColor
          }),
          stroke: new Stroke({
            color: featureStyle.modifyCircleStrokeColor,
            width: featureStyle.modifyCircleStrokeWidth
          })
        })
      })
    });
    var snapInt = new Snap({
      source: layerSource
    });
    map._drawLayers[this.id] = {
      layer: layer,
      layerSource: layerSource,
      drawInt: drawInt,
      modifyInt: modifyInt,
      snapInt: snapInt
    };
    this.mountLayer();
  };
  _proto.bindListeners = function bindListeners() {
    var _this$props2 = this.props,
      map = _this$props2.map,
      onDrawend = _this$props2.onDrawend,
      onModifyend = _this$props2.onModifyend;
    var _map$_drawLayers$this = map._drawLayers[this.id],
      layerSource = _map$_drawLayers$this.layerSource,
      drawInt = _map$_drawLayers$this.drawInt,
      modifyInt = _map$_drawLayers$this.modifyInt;
    drawInt.on('drawend', function (evt) {
      setTimeout(function () {
        onDrawend(evt.feature);
      }, 50);
      // onDrawend(evt.feature);
      // this.isDrawing = false;
    });
    drawInt.on('drawstart', function () {
      // this.isDrawing = true;
      layerSource.clear();
    });
    modifyInt.on('modifyend', function (evt) {
      var f = evt.features.getArray()[0];
      evt.features.forEach(function (fs) {
        if (fs.getRevision() > f.getRevision()) {
          f = fs;
        }
      });
      setTimeout(function () {
        return onModifyend(f);
      }, 50);
    });
  };
  _proto.mountLayer = function mountLayer() {
    var _this$props3 = this.props,
      map = _this$props3.map,
      features = _this$props3.features;
    if (!map) {
      setTimeout(this.mountLayer.bind(this), 200);
      return;
    }
    var _map$_drawLayers$this2 = map._drawLayers[this.id],
      layer = _map$_drawLayers$this2.layer,
      drawInt = _map$_drawLayers$this2.drawInt,
      modifyInt = _map$_drawLayers$this2.modifyInt,
      snapInt = _map$_drawLayers$this2.snapInt;
    this.bindListeners();
    map.addLayer(layer);
    map.addInteraction(drawInt);
    map.addInteraction(modifyInt);
    map.addInteraction(snapInt);
    this.toggleInteractions(this.props);
    this.updateFeatures(features);
  };
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // this.updateFeatures(nextProps.features);
    this.toggleInteractions(nextProps);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate() {
    return !this.isDrawing;
  };
  _proto.updateFeatures = function updateFeatures(features) {
    var layerSource = this.props.map._drawLayers[this.id].layerSource;
    var newFeatures = [];
    var efs = layerSource.getFeatures();
    features.forEach(function (f) {
      if (efs.length === 0 || !efs.find(function (ef) {
        return ef.ol_uid === f.ol_uid;
      })) {
        newFeatures.push(f);
      }
    });
    if (newFeatures.length === features.length) {
      layerSource.clear();
    }
    layerSource.addFeatures(newFeatures);
  };
  _proto.toggleInteractions = function toggleInteractions(props) {
    var map = props.map,
      draw = props.draw,
      modify = props.modify,
      snap = props.snap;
    var _map$_drawLayers$this3 = map._drawLayers[this.id],
      drawInt = _map$_drawLayers$this3.drawInt,
      modifyInt = _map$_drawLayers$this3.modifyInt,
      snapInt = _map$_drawLayers$this3.snapInt;
    drawInt.setActive(draw);
    modifyInt.setActive(modify);
    snapInt.setActive(snap);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;
    var _map$_drawLayers$this4 = map._drawLayers[this.id],
      layer = _map$_drawLayers$this4.layer,
      drawInt = _map$_drawLayers$this4.drawInt,
      modifyInt = _map$_drawLayers$this4.modifyInt,
      snapInt = _map$_drawLayers$this4.snapInt;
    map.removeInteraction(modifyInt);
    map.removeInteraction(drawInt);
    map.removeInteraction(snapInt);
    map.removeLayer(layer);
  };
  _proto.render = function render() {
    var map = this.props.map;
    if (map._drawLayer && map._drawLayer[this.id].layerSource) {
      this.updateFeatures(this.props.features);
    }
    return /*#__PURE__*/React.createElement("span", null);
  };
  _proto.zoomToExtent = function zoomToExtent() {
    var _this$props4 = this.props,
      fitViewAndZoom = _this$props4.fitViewAndZoom,
      maxZoom = _this$props4.maxZoom;
    fitViewAndZoom(this.map._drawLayerSources[this.id].getExtent(), maxZoom);
  };
  return _createClass(DrawLayer, [{
    key: "id",
    get: function get() {
      return this.props.layerName;
    }
  }]);
}(React.Component);
DrawLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   *  Name
   */
  name: PropTypes.string,
  /**
   * Geometry type of the geometries being drawn with this instance
   * @param {string} geomety geometry type from ol/geom/GeometryType <br/>
   * The geometry type. One of `Point`, `LineString`, `Polygon`, `Circle`.
   */
  olGeomType: PropTypes.string.isRequired,
  /**
   *  Destination collection for the drawn features
   */
  features: PropTypes.array.isRequired,
  /**
   *  Name of the layer
   */
  layerName: PropTypes.string.isRequired,
  /**
   *  If set, do not allow higher zoom level than provided value.
   */
  maxZoom: PropTypes.number,
  /**
   *  If set, enables you to modify drawn features.
   */
  modify: PropTypes.bool,
  /**
   *  If set, enables you to draw features
   */
  draw: PropTypes.bool,
  /**
   *  If set, snaps to feature (when you are near) you want to modify
   */
  snap: PropTypes.bool,
  /**
   * Listener function for the 'drawend' event of an ol.interaction.Draw.<br/>
   * See https://openlayers.org/en/latest/apidoc/module-ol_interaction_Draw-DrawEvent.html<br/>
   * for more information.
   */
  onDrawend: PropTypes.func,
  /**
   * Listener function for the 'modifyend' event of an ol.interaction.Modify.<br/>
   * See https://openlayers.org/en/latest/apidoc/module-ol_interaction_Modify.ModifyEvent.html<br/>
   * for more information.
   */
  onModifyend: PropTypes.func,
  /**
   *  Style for sketch features.
   */
  featureStyle: LayerStyle,
  /**
   * Instance of OL map this component is bound to.
   */
  map: PropTypes.object,
  /**
   * Listener function for the 'fit' event of an ol.view.<br/>
   * See https://openlayers.org/en/latest/apidoc/module-ol_View-View.html#fit <br/>
   * for more information.
   * @param {geometry} geometryOrExtent [geometry](https://openlayers.org/en/latest/apidoc/module-ol_geom_SimpleGeometry-SimpleGeometry.html) | [extent](https://openlayers.org/en/latest/apidoc/module-ol_extent.html#~Extent) -
   * The geometry or extent to fit the view to.<br/>
   * <br/>
   *
   *
   * @param {object[]} options - options
   * @param {number} options.maxZoom Maximum zoom level that we zoom to. If maxZoom is not given, this property is undefined.
   * @param {number} options.duration number The duration of the animation in milliseconds. By default, there is no animation to the target extent.
   * @param {array.number} options.padding Padding (in pixels) to be cleared inside the view. Values in the array are top, right, bottom and left padding.
   *
   */
  fitViewAndZoom: PropTypes.func.isRequired
} : {};
export default provideMapState(ensureMap(DrawLayer));